import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  PaletteMode,
  Radio,
  RadioGroup,
} from "@mui/material";

import LocalStorage from "services/LocalStorage";
import useBoundStore from "store";

interface EditThemeDialogProps {
  open: boolean;
  onClose: () => void;
}

function EditThemeDialog(props: EditThemeDialogProps) {
  const { onClose, open } = props;
  const theme = useBoundStore((state) => state.generalSettings.theme);
  const setGeneralSettings = useBoundStore((state) => state.generalSettings.set);
  const localStorage = LocalStorage.getInstance();

  const handleSelectTheme = (e: React.ChangeEvent<HTMLInputElement>) => {
    const themeType = e.target.value as PaletteMode;
    localStorage.setPaletteMode(themeType);
    setGeneralSettings({ theme: themeType });
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby='theme-dialog' maxWidth='xs' fullWidth>
      <DialogTitle id='theme-dialog'>Choose theme</DialogTitle>
      <DialogContent>
        <FormControl component='fieldset'>
          <RadioGroup aria-label='theme' name='theme' value={theme} onChange={handleSelectTheme}>
            <FormControlLabel value='light' control={<Radio />} label='Light' />
            <FormControlLabel value='dark' control={<Radio />} label='Dark' />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditThemeDialog;
